<template>
  <div v-role="'func'">
    <!-- Overlay de carregamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Container de informações principais -->
    <div class="top_info_container">
      <!-- Botão para registrar um novo bolseiro, visível apenas se o usuário tiver a função apropriada -->
      <v-btn 
        v-if="funcaoPorROle.verificarFuncao(4)" 
        @click="$router.push('/esc-pagamento')" 
        style="background-color:#006699; color:white;" 
        outlined
      >
        <v-icon md color="white">add</v-icon> Registrar Bolseiro
      </v-btn>
      <v-toolbar-title class="titulo_pagina">Lista dos bolseiros Revogados</v-toolbar-title>
    </div>

    <!-- Tabela de dados dos bolseiros revogados -->
    <v-data-table :headers="headers" :items="bolseiros" :items-per-page="8">
      <!-- Coluna de índice personalizada -->
      <template v-slot:item.indice="{ item }">
        <span>{{ bolseiros.indexOf(item) + 1 }}</span>
      </template>

      <!-- Coluna de desconto personalizada -->
      <template v-slot:item.desconto="{ item }">
        <span>
          {{ item.isPercentagem === 1 ? item.desconto + '%' : utilitarios.IntegerToMoneyValueFatura(item.desconto) }}
        </span>
      </template>

      <!-- Coluna de ação, com menu para ativar a bolsa -->
      <template v-slot:item.action="{ item }">
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab dark small color="#006699" v-bind="attrs" v-on="on">
              <v-icon dark>menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <!-- Opção para ativar a bolsa, visível apenas se o usuário tiver a função apropriada -->
            <v-list-item v-if="funcaoPorROle.verificarFuncao(23)" @click="ActivarBolsa(item)">
              <v-icon color="green">done</v-icon> Activar Bolsa
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import Swal from 'sweetalert2';
import axios from '../../plugins/axios';
import funcaoPorROle from '../../utilitarios/funcao.untilitario';
import utilitarios from "../../plugins/utilitarios";

export default {
  data: () => ({
    funcaoPorROle,
    overlay: false,
    utilitarios,
    bolseiros: [],
    headers: [
      { text: '#', value: 'indice' },
      { text: 'Nome', align: 'start', sortable: false, value: 'nome' },
      { text: 'Bilhete', value: 'bi' },
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Curso', value: 'curso' },
      { text: 'Organização', value: 'ongBolsa' },
      { text: 'Desconto', value: 'desconto' },
      { text: 'Ação', value: 'action' }
    ],
  }),

  created() {
    this.listarBolseiros();
  },

  methods: {
    /**
     * Carrega a lista de bolseiros revogados a partir do backend.
     * Em caso de erro, exibe uma notificação de erro.
     */
    async listarBolseiros() {
      this.overlay = true;
      try {
        const response = await axios.get('/listarBolseirosRevogados');
        this.bolseiros = response.data;
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante o carregamento da página', 'error'); // Exibe notificação de erro
      } finally {
        this.overlay = false;
      }
    },

    /**
     * Reativa a bolsa de um estudante.
     * Caso haja sucesso, a lista de bolseiros será atualizada e uma mensagem de sucesso será exibida.
     * Em caso de erro, exibe uma notificação de erro.
     * @param {Object} estudante - Objeto do estudante cuja bolsa será reativada
     */
    async ActivarBolsa(estudante) {
      this.overlay = true;
      try {
        const params = { matricula: estudante.matricula };
        const operacao = await axios.post('/reativarBolsaEstudante', params);

        if (operacao.status === 200 && operacao.data.affectedRows >= 1) {
          Swal.fire('Sucesso', 'Bolseiro reactivado com sucesso!', 'success');
          this.listarBolseiros();
        }
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante a reactivação da bolsa!', 'error'); // Exibe notificação de erro
      } finally {
        this.overlay = false;
      }
    }
  }
}
</script>


<style scoped>
/* Estilos específicos podem ser adicionados aqui, caso necessário */
</style>
